<template>
  <v-app>
    <OfflineIndicator />    
    <component v-bind:is="layout">
      <slot/>
    </component>
    <NotificationsList />
  </v-app>  
</template>

<script>
const BaseLayout = () =>
  import(/* webpackChunkName: "vts-layout-default" */ './layouts/BaseLayout')
const NoHeaderLayout = () =>
  import(/* webpackChunkName: "vts-layout-no-header"*/ './layouts/NoHeaderLayout')
const NotificationsList = () =>
  import(/* webpackChunkName: "vts-notifications-list"*/ './components/notification/NotificationsList')
const OfflineIndicator = () =>
  import(/* webpackChunkName: "vts-offline-indicator"*/ './components/internetDetector/OfflineIndicator')

export default {
  computed: {
    layout() {
      return `${this.$route.meta.layout || 'base'}-layout`
    }
  },
  components: {
    BaseLayout,
    NoHeaderLayout,
    NotificationsList,
    OfflineIndicator
  }
}
</script>
